const handle = "_35shstsnoj";

export { handle };
import "./atom.drag-handle.style.linaria.module.css";
//# sourceMappingURL=atom.drag-handle.style.js.map
